// src/views/Settings/account/ProjectsSection.jsx
//
// Los proyectos de la cuenta. Cuelgan de aquí porque son suyos: en la base de
// datos un proyecto lleva `account_id` u `organization_id`, nunca `user_id`.
//
// Aquí se listan y se administran: buscar, filtrar, crear. Lo que hay *dentro*
// de un proyecto —sus agentes, sus workflows, su galería, el chat de un
// agente— no se abre aquí. Eso es la app, no los ajustes de la cuenta, y
// montarlo dentro dejaba el workspace de un agente colgando de una pantalla de
// configuración, con el menú de secciones al lado.
//
// Así que `ProjectsView` se monta en modo lista y abrir un proyecto sale a
// `/dashboard?view=Projects`, que es donde el workspace vive.
import React from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import ProjectsView from '../../../components/ProjectsView/ProjectsView';

export default function ProjectsSection() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Un enlace guardado de cuando el detalle sí se abría aquí. Se manda entero a
  // la app —`projectId`, `tab`, `agentId`, `section`— para que aterrice en el
  // agente y no en la lista.
  const deepLink = searchParams.get('projectId') || searchParams.get('agentId');
  if (deepLink) {
    const params = new URLSearchParams(searchParams);
    params.set('view', 'Projects');
    return <Navigate to={`/dashboard?${params.toString()}`} replace />;
  }

  return (
    // `ProjectsView` es `h-full` y quien la monte tiene que darle altura: si no,
    // se colapsa y la lista deja de poder desplazarse. El shell es una columna
    // flex, así que basta con ocupar lo que sobre.
    <div className="flex min-h-0 flex-1 flex-col">
      {/* Sin `view=Projects`: la ruta ya selecciona esta vista, y escribirlo
          dejaría en la URL un parámetro que aquí no significa nada. */}
      <ProjectsView
        baseParams={{}}
        onOpenProject={(project) =>
          navigate(
            `/dashboard?view=Projects&projectId=${encodeURIComponent(
              project.project_id
            )}&tab=assistants`
          )
        }
      />
    </div>
  );
}
